import React from 'react';
import styled from 'styled-components';
import palette from '../../lib/styles/palette';
import { timeValueToDate } from '../../lib/commonFunc/commonFunc';
import Loading from '../common/Loading';
import { MdDelete } from 'react-icons/md';

// const TitleBlock = styled.div`
//   display: flex;
//   align-items: center;
// `;
// const Title = styled.h2`
//   font-size: 18px;
//   color: ${palette.webGray[10]};
//   font-weight: 600;
//   margin-left: 5px;
//   margin-top: 0;
//   margin-bottom: 0;
// `;

const PrescriptionBlock = styled.div`
  width: 100%;
`;

const ItemBlock = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 125px;
  border-bottom: 1px solid hsla(0, 0%, 0%, 0.08);
  padding: 5px 16px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: #f8f9fa;
  }
  
  & + & {
    margin-top: 1rem;
  }
`;

const Info = styled.div`
  justify-content: center;
  align-items: center;
  flex: 1;
`;

const DeleteButton = styled.button`
  padding: 8px;
  cursor: pointer;
  background: transparent;
  border: none;
  color: #999;
  transition: all 0.2s ease;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #d32f2f;
    background-color: #ffebee;
  }

  svg {
    font-size: 20px;
  }
`;
// const Action = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   padding: 0 15px;
//   svg {
//     font-size: 1.5rem;
//     cursor: pointer;
//   }
// `;
const TopLine = styled.div`
  display: block;
`;
const PrescriptionName = styled.h2`
  font-size: 1.125rem;
  color: ${palette.webGray[13]};
  font-weight: 400;
  display: inline-block;
  margin-right: 15px;
`;

// const Mark = styled.div`
//   border-radius: 0.2rem;
//   background: ${palette.webCyan[5]};
//   color: ${palette.white};
//   padding: 2px 12px;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   display: inline-block;
// `;

const RegistDate = styled.div`
  color: ${palette.webGray[12]};
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
`;

const EmptyBlock = styled.div`
  height: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoadProgramStepTwo = ({
  prescriptions,
  onSetStep,
  onTempSetProgram,
  loading,
  onDeleteProgram,
}) => {
  if (loading) return <Loading />;
  return (
    <>
      <PrescriptionBlock>
        {prescriptions && prescriptions.length > 0 ? (
          prescriptions.map((item) => (
            <ItemBlock key={item.fcProgramID}>
              <Info
                onClick={() => {
                  onTempSetProgram(item);
                  onSetStep(3);
                }}
              >
                <TopLine>
                  <PrescriptionName>{item.name}</PrescriptionName>
                </TopLine>
                <RegistDate>{timeValueToDate(item.registTime)}</RegistDate>
              </Info>
              <DeleteButton
                onClick={(e) => {
                  e.stopPropagation();
                  if (window.confirm(`"${item.name}" 프로그램을 삭제하시겠습니까?`)) {
                    onDeleteProgram(item.fcProgramID);
                  }
                }}
              >
                <MdDelete />
              </DeleteButton>
            </ItemBlock>
          ))
        ) : (
          <EmptyBlock>불러올 프로그램이 없습니다.</EmptyBlock>
        )}
      </PrescriptionBlock>
    </>
  );
};

export default LoadProgramStepTwo;
